import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { EditPageHeader } from '../../components/EditPageHeader'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { ENTITYNAME, TOAST_TYPES, VERSION_TYPE } from '../../framework/constant/constant'
import * as API from '../../framework/API/api'
import { useTranslation } from '../../locale/useTranslation';
import ToastNotification from '../../components/ToastNotification'

const MediaEpisodeIngestMAMPopup = (props) => {
    const lang = useTranslation();
    const [dataItem, setDataItem] = useState({});
    const [transmissionTypes, setTransmissionTypes] = useState([]);
    const [ingestPrototypes, setIngestPrototypes] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [])


    const loadCombo = async () => {

        let transmissionTypeRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { SID: 1 } });
        setTransmissionTypes(transmissionTypeRes.data);

        let ingestPrototypeRes = await API.getDataLookup(ENTITYNAME.INGEST_PROTOTYPE, { sort: { SID: 1 } });
        setIngestPrototypes(ingestPrototypeRes.data);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    }

    const isValid = () => {

        if (!dataItem.versionType || Object.keys(dataItem.versionType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_verison_type_error_message });
            return false;
        }
        if (!dataItem.transmissionType || Object.keys(dataItem.transmissionType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_transmission_type_error_message });
            return false;
        }
        if (!dataItem.ingestProtoType || Object.keys(dataItem.ingestProtoType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_ingest_prototype_error_message });
            return false;
        }

        return true;

    }

    const onSubmit = () => {

        if (!isValid()) return;

        props.createMAMAssetAndWO(dataItem);
        setDataItem({});
    }

    return (<BossDialog onClose={props.onClose} title={lang.select_mam_ingestion_header} width={"20vw"}>
        <EditPageHeader showTitle={false} onCancel={props.onClose} onSubmit={onSubmit} />
        <div className="row mt-2">
            <div className="col-12 ">
                <label>{lang.version_type_label} *</label>
                <DropDownList
                    data={Object.keys(VERSION_TYPE).map((x) => ({ _id: VERSION_TYPE[x], Description: x }))}
                    name="versionType"
                    valueField="_id"
                    textField="Description"
                    value={dataItem.versionType}
                    onChange={onChange}
                /></div>
            <div className="col-12 mt-2">
                <label>{lang.transmission_type_label} *</label>
                <DropDownList
                    data={transmissionTypes}
                    name="transmissionType"
                    valueField="_id"
                    textField="Name"
                    value={dataItem.transmissionType}
                    onChange={onChange}
                /></div>
            <div className="col-12 mt-2">
                <label>{lang.ingest_prototype_label} *</label>
                <DropDownList
                    data={dataItem.transmissionType ? ingestPrototypes.filter((x) => x.TransmissionType?._id == dataItem?.transmissionType?._id) : []}
                    name="ingestProtoType"
                    valueField="_id"
                    textField="Description"
                    value={dataItem.ingestProtoType}
                    onChange={onChange}
                /></div>

        </div>

    </BossDialog>)
}

export default MediaEpisodeIngestMAMPopup